// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__tXRto","range":"MonthRangeSwitch_range___XGaS","disabled":"MonthRangeSwitch_disabled__oRYPN"};